import React from 'react';
import icons from '../Images/profile-icons.png'
function Testimonials() {
  return (
    <div className="max-w-full mx-auto px-5 text-center text-[#2b2f1f] font-montserrat mb-20">
      <h2 className="text-[40px] font-bold mb-2">Clients Say!</h2>
      <p className="text-[25px] font-normal mb-6 leading-relaxed">
        With years of experience and satisfied customers,
        <br />
        we guarantee quality results.
      </p>
      <div className="text-6xl font-bold mb-16" aria-label="Average rating 4.8 out of 5">
        4.8/5
      </div>
      <h3 className="text-3xl font-bold mb-20">Average Customer Rating / Reviews</h3>

      <section className="flex flex-wrap justify-center gap-14" aria-label="Client testimonials">
        {/* Client 1 */}
        <article className="max-w-[300px]">
          <div className="w-[100px] h-[100px] mx-auto mb-3 flex items-center justify-center">
            <img
              src={icons}
              alt="Silhouette of a person icon in dark green on light green circular background"
              className="w-[60px] h-[60px]"
            />
          </div>
           <div className="text-[20px] font-medium mb-1">Sudhir Singh</div>
          <div className="text-[17px] font-normal mb-3">I struggled with weight loss for years, trying every diet I could find. After working with Niharika Jain, I finally understood what my body really needs. I feel healthier, more energetic, and I've lost weight in a sustainable way!</div>
          <div className="text-lg" aria-label="4 star rating">
            ★★★★☆
          </div>
        </article>

        {/* Client 2 */}
        <article className="max-w-[300px]">
          <div className="w-[100px] h-[100px] mx-auto mb-3 flex items-center justify-center">
            <img
              src={icons}
              alt="Silhouette of a person icon in dark green on light green circular background"
              className="w-[60px] h-[60px]"
            />
          </div>
          <div className="text-[20px] font-medium mb-1">Rakha Mahesavari</div>
          <div className="text-[17px] font-normal mb-3">The personalized meal plans were a game-changer for me. They weren't restrictive, and I never felt deprived. My digestion has improved, my skin is glowing, and I have so much more confidence in my lifestyle choices now!</div>
          <div className="text-lg" aria-label="4 star rating">
            ★★★★★
          </div>
        </article>

        {/* Client 3 */}
        <article className="max-w-[300px]">
          <div className="w-[100px] h-[100px] mx-auto mb-3  flex items-center justify-center">
            <img
              src={icons}
              alt="Silhouette of a person icon in dark green on light green circular background"
              className="w-[60px] h-[60px]"
            />
          </div>
           <div className="text-[20px] font-medium mb-1">Abhishek Sharma</div>
          <div className="text-[17px] font-normal mb-3">I always thought eating healthy meant complicated recipes and bland food. But with Niharika Jain guidance, I learned how to enjoy simple, delicious meals that actually nourish my body. My whole family eats better now!</div>
          <div className="text-lg" aria-label="4 star rating">
            ★★★☆
          </div>
        </article>
      </section>
    </div>
  );
}

export default Testimonials;
